module.exports = __webpack_public_path__ + "images/cfb82a3c3a34b2bd6a4d892f4c700d87.png";